<template>
<v-app id="app">
    <v-app-bar app color="primary" elevation="0" dense v-if="isLogged">
        <v-app-bar-nav-icon @click="toggleMini = !toggleMini" color="white"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <v-menu
          offset-y
          v-if="isLogged"
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              class="white--text ma-2 m-auto"
              v-bind="attrs"
              v-on="on"
              text
              icon
            >
              <v-avatar>
                <img
                  src="/assets/images/no_user.png"
                  alt="user"
                  style="width:35px;height:35px"
                >
              </v-avatar>
            </v-btn>
          </template>

          <v-list
          style="width:130px !important;border-radius:0 !important"
          >
           <v-list-item
              link 
            >
              <v-list-item-title style="padding:5px 5px !important;height: auto !important;margin:0 !important;font-size:15px;float:left !important">
                <v-icon>mdi-account-check-outline</v-icon>
                <span style="padding-left:3% !important">Profile</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              link
              @click="logout()" 
            >
              <v-list-item-title style="padding:5px 5px !important;height: auto !important;margin:0 !important;font-size:15px;float:left !important">
                <v-icon>mdi-logout-variant</v-icon>
                <span style="padding-left:3% !important" @click="logout()">Logout</span>
              </v-list-item-title>
            </v-list-item>
           
          </v-list>
        </v-menu>
    </v-app-bar>
      <v-navigation-drawer 
          v-model="toggleMini" 
          v-if="isLogged"
          app
          :mini-variant.sync="mini"
          elevation="0"
          stateless
          light
          class="menudrawer"
          >
          <v-list color="brand" dense>
              <v-list-item class="py-2">
                  <v-list-item-content>
                      <router-link link :to="{name: 'Dashboard'}" style="text-decoration:none !important;color:inherit !important">
                        <v-list-item-title class="text-center">
                            <!-- <h3 class="font-weight-bold">Mobi POS</h3> -->
                            <img src="/assets/mlogo.png" style="width:80% !important;text-align:center">
                        </v-list-item-title>
                      </router-link>
                  </v-list-item-content>
              </v-list-item>
          </v-list>
          <v-list-item class="px-2 py-2 primary" @click="mini = !mini" v-if="isLogged">
              <v-list-item-avatar>
                  <v-icon color="white">mdi-domain</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="text-truncate font-weight-bold">
                  <span v-for="(store, index) in $store.state.user.user.store">
                    <b v-if="store.status == 'Active'" style="font-size:.95rem !important;color:#fff !important;text-transform:uppercase !important;font-weight:normal !important">{{ store.store_name }}</b>
                  </span>
              </v-list-item-content>
              <v-btn icon small>
                  <v-icon color="white" @click.stop="mini = !mini">mdi-chevron-left</v-icon>
              </v-btn>
          </v-list-item>
          <v-divider></v-divider>
          <v-list class="sidenav" v-if="isLogged">

            <v-list-item link to="/" v-if="$can('view-dashboard', 'all')">
              <v-list-item-icon>
                  <v-icon color="primary">mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

         <!--    <v-list-item link to="/point-of-sale" v-if="$can('pos', 'all')">
              <v-list-item-icon>
                  <v-icon color="primary">mdi-printer-pos</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">POS</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- first list group -->
            <v-list-group
              v-for="item in products"
              :key="item.title"
              no-action
              v-if="$can('inventory-management', 'all')"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" class="font-weight-medium"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.title"
                link 
                :to="subItem.href"
              >
                <!-- <v-list-item-content> -->
                    <v-list-item-title class="black--text" v-text="subItem.title"></v-list-item-title>
                    <v-list-item-icon>
                      <v-avatar
                        color="rgba(0,0,0,.05)"
                        size="25"
                      >
                        <span class="black--text" v-text="subItem.icon"></span>
                      </v-avatar>
                    </v-list-item-icon>
                <!-- </v-list-item-content> -->
                
              </v-list-item>
              <v-divider></v-divider>
            </v-list-group>
            <!-- end first group -->

            <!-- third list group -->
            <v-list-group
              v-for="item in reports"
              :key="item.title"
              no-action
              v-if="$can('user-management', 'all')"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" class="font-weight-medium"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.title"
                link 
                :to="subItem.href"
              >
                <!-- <v-list-item-content> -->
                  <v-list-item-title class="black--text" v-text="subItem.title"></v-list-item-title>
                  <v-list-item-icon>
                      <v-avatar
                        color="rgba(0,0,0,.05)"
                        size="25"
                      >
                        <span class="black--text" v-text="subItem.icon"></span>
                      </v-avatar>
                    </v-list-item-icon>
                <!-- </v-list-item-content> -->
              </v-list-item>
              <v-divider></v-divider>
            </v-list-group>
            <!-- end third group -->

          </v-list>
      </v-navigation-drawer>
    <v-main>
        <v-container fluid>
          <v-row style="background:#1A1EB8;height:15rem;position:fixed;top:0;right:0;left:0" v-if="isLogged"></v-row>
            <v-row>
                <v-col cols="12" style="margin-top:0 !important">
                    <router-view></router-view>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
    <!-- <v-footer style="padding:7px 5px !important">
        <span class="ml-auto">Abslute Cabs &copy;2021</span>
    </v-footer> -->
</v-app>
</template>
<style>
  .notificationbell .v-badge__badge{
      inset: auto auto calc(100% - 24px) calc(100% - 24px) !important;
}
</style>
<style scoped>

.v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group>.v-list-group__items>.v-list-item {
    padding-left: 64px !important;
}
.v-main{
      padding: 48px 0px 0px 200px;
}
  .v-list.brand{
    padding: 0 !important;
  }
  .v-list, .v-list-item, .v-list-item__title{
    font-size: 14px !important;
  }
 
  .v-list-item{
    font-weight: normal !important;
  }
</style>
<script>
import { mapGetters } from 'vuex'
import { Can } from '@casl/vue'
 export default {
  name: 'App',
  components: {
    Can,
  },

  computed: {
    ...mapGetters([
      'isLogged'
    ]),
    alldashboard () {
      return this.$store.state.items
    }
  },
  data: () => ({
      sidebarMenu: true,
      toggleMini: true,
      mini: false,
      active: false,
      products: [
        {
          title: 'Products',
          icon: 'mdi-sitemap',
          color: 'primary',
          items: [
            { title:"Items", href:"/products/list",icon:"I"},
            { title:"Categories", href:"/category/list",icon:"C"},
            { title:"Sub Categories", href:"/subcategory/list",icon:"SC"},
            { title:"Suppliers", href:"/suppliers/list",icon:"S"},
            { title:"Promotions", href:"/promotions/list",icon:"P"},
            { title:"Sliders", href:"/sliders/list",icon:"s"},
            { title:"Adverts", href:"/ads/list",icon:"A"},
            { title:"Pick of Day", href:"/pick-of-the-day/list",icon:"POD"}
          ]
        }
      ],
      reports: [
        {
          title: 'Reports',
          icon: 'mdi-chart-bar',
          color: 'primary',
          items: [
            { title:"Sales Summary", href:"/reports/sales-summary",icon:"SS"},
            { title:"Sales by Item", href:"/reports/sales-item",icon:"SI"},
            { title:"Sales by Category", href:"/reports/sales-category",icon:"SC"},
            { title:"Receipts", href:"/sales/receipts",icon:"R"},
          ]
        },
        {
          title: 'Customers',
          icon: 'mdi-account',
          color: 'primary',
          items: [
            { title:"Customer List", href:"/customers/list",icon:"C"},
          ]
        },
        {
          title: 'User Config',
          icon: 'mdi-account-cog-outline',
          color: 'primary',
          items: [
            { title:"Users", href:"/users/list",icon:"U"},
            { title:"Permissions", href:"/permission/list",icon:"P"},
            { title:"Roles", href:"/role/list",icon:"R"},
          ]
        }
      ]
  }),
  mounted() {

    this.$parent.$on('toggleNav', () => {
      this.collapses = !this.collapses
      this.navwidth = !this.navwidth
      this.navleft = !this.navleft
      this.appadding = !this.appadding
      this.appleft = !this.appleft
      this.headerActive = !this.headerActive
      this.showIcon = !this.showIcon
    })

    if(this.isLogged) {
      if(!this.$store.state.items || this.$store.state.items.length == 0) {
        this.getDashboard()
      }
    }

     var pusher = new Pusher('520ce8cd4da6077ae6b2', {
        cluster: 'ap2'
      });
      // add package
      var channel = pusher.subscribe('addPackage');
      channel.bind('packageAdded', data => {
          this.$store.dispatch('addpackage', data.data)
      })
      // add
      var channel = pusher.subscribe('addStock');
      channel.bind('stockAdded', data => {
          this.$store.dispatch('addstock', data.data)
      })
      // new
      var channel = pusher.subscribe('createProduct');
      channel.bind('productCreated', data => {
          this.$store.dispatch('productnew', data.data)
      })
      // edit
      var editchannel = pusher.subscribe('updateProduct');
      editchannel.bind('productUpdated', data => {
          this.$store.dispatch('productupdate', data.data)
      })
      // delete
      var deletechannel = pusher.subscribe('deleteProduct');
      deletechannel.bind('productDeleted', data => {
          this.$store.dispatch('productdelete', data.data)
      })
      // new
      var newcustomer = pusher.subscribe('newcustomer');
      newcustomer.bind('newcustomer', data => {
          this.$store.dispatch('newcustomer', data.data)
      })
      // edit
      var editcustomer = pusher.subscribe('updatecustomer');
      editcustomer.bind('updatecustomer', data => {
          this.$store.dispatch('updatecustomer', data.data)
      })
      // delete
      var deletecustomer = pusher.subscribe('deletecustomer');
      deletecustomer.bind('deletecustomer', data => {
          this.$store.dispatch('deletecustomer', data.data)
      })
    
  },
  serverPrefetch () {
      return this.getDashboard()
    },
  methods: {
    async getDashboard(){
      this.$store
        .dispatch('getDashboard')
        .then(() => {
        })
        .catch(() => {
        })
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
};
</script>
